import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import RootReducer from 'Store/Reducers/RootReducer';

const logger = createLogger({
  collapsed: true,
});

// Configure redux-persist with masterData whitelist and 10-minute expiration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['masterData'], // Only persist master data
  transforms: [
    {
      in: (state) => ({
        ...state,
        _persistedAt: Date.now(), // Add timestamp when persisting
      }),
      out: (state) => {
        const expirationTime = 10 * 60 * 1000; // 10 minutes in milliseconds
        const timeDifference = Date.now() - state._persistedAt;
        // Return undefined if expired, causing rehydration to skip this state
        return timeDifference > expirationTime ? undefined : state;
      },
    },
  ],
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(process.env.NODE_ENV !== 'production' ? [logger] : []),
  devTools: process.env.NODE_ENV !== 'production',
});

const persistor = persistStore(store);

export { store, persistor };
export default store;
